import React from "react";
import Dialog from "../../../../common/element/Dialog";

const CandidateToolResult = ({ dialogOpen, onDialogClose }) => {
  // Sample Data
  const assessmentResults = [
    { id: 1, personality: "Reformer (Type 1)", score: "01" },
    { id: 2, personality: "Giver (Type 2)", score: "02" },
    { id: 3, personality: "Achiever (Type 3)", score: "03" },
    { id: 4, personality: "Individualist (Type 4)", score: "04" },
    { id: 5, personality: "Individualist (Type 4)", score: "05" },
    { id: 6, personality: "Sentinel (Type 6)", score: "06" },
  ];

  return (
    <Dialog
      isOpen={dialogOpen}
      onClose={onDialogClose}
      onRequestClose={onDialogClose} // 👈 ensures click outside also closes
      width={700}
      bodyOpenClassName="overflow-hidden"
      closeOnOverlayClick={true} // 👈 optional — depends on your Dialog implementation
    >
      {/* Header */}
      <div className="flex border-b px-6 py-4 items-center justify-between">
        <div className="flex items-center">
          <span className="h-10 w-10 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-3">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 4H20V20H4V4ZM8 8H16M8 12H16M8 16H12"
                stroke="#344054"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h5 className="text-gray-900 text-lg font-semibold">
            View Assessment Result
          </h5>
        </div>

        <button
          onClick={onDialogClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="px-6 py-5">
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden text-sm">
            <thead className="bg-orange-50 text-gray-700 text-left">
              <tr>
                <th className="py-3 px-4 font-semibold border-b border-gray-200 w-1/5">
                  S. No.
                </th>
                <th className="py-3 px-4 font-semibold border-b border-gray-200 w-3/5">
                  Personality Type
                </th>
                <th className="py-3 px-4 font-semibold border-b border-gray-200 w-1/5">
                  Your Score
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {assessmentResults.map((result) => (
                <tr
                  key={result.id}
                  className="border-b border-gray-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-gray-800 text-center">
                    {String(result.id).padStart(2, "0")}
                  </td>
                  <td className="py-3 px-4 text-gray-800">
                    {result.personality}
                  </td>
                  <td className="py-3 px-4 text-gray-800 text-center">
                    {result.score}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-end border-t px-6 py-4">
        <button
          className="whiteBtnShadow btn border border-gray-100 rounded-lg h-10 px-5 bg-[#FFF4E5] text-gray-700 text-sm font-semibold hover:bg-[#FFE4CC] transition-colors duration-100"
          onClick={onDialogClose}
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default CandidateToolResult;
